import type React from 'react';
import { createContext, useContext, useMemo, useState } from 'react';

export const TitleContext = createContext({
  title: '',
  setTitle: (_: string) => {},
});
export const useTitle = () => useContext(TitleContext);

type Props = {
  children: React.ReactNode;
};

const TitleProvider = ({ children }: Props) => {
  const [title, setTitle] = useState<string>('');

  const value = useMemo(() => ({ title, setTitle }), [title]);

  return <TitleContext.Provider value={value}>{children}</TitleContext.Provider>;
};

export default TitleProvider;
